
import IMG1 from "./assets/Screenshot_1617151867.png";
import IMG3 from "./assets/Screenshot_1619918992.png";
import IMG4 from "./assets/Screenshot_1619919006.png";
import IMG5 from "./assets/Screenshot_1619919011.png";
import IMG6 from "./assets/Screenshot_1619919025.png";
import IMG7 from "./assets/Screenshot_1619919038.png";
import IMG8 from "./assets/Screenshot_1619919050.png";
import IMG9 from "./assets/Screenshot_1619919073.png";
import IMG11 from "./assets/Screenshot_1619919123.png";
import profile from "./assets/Profile.jpeg"
export default {
    projects: [{
        name: "Interpreter Typescript",
        text: "Online interpreter for typescript",
        data: {
            technologies: [
                "Angular",
                "TypeScript",
                "Ace Editor",
                "SweetAlert2"
            ],
            description: "In this page you can run typescript code, also see if it has mistakes and another reports about your code",
            link: "https://josemoran40.github.io/Proyecto1_Compi2/",
            images: [
                "../../assets/IMG1.png"
            ]
        },
        type: "web",
        code: "https://github.com/PvasquezF/ArchivosPruebaOLC2/blob/master/MatrioshTS-2s2020/FuncionesRescursivas.ts"
    },
    {
        name: "Type3D",
        text: "Typescript 3D compiler",
        data: {
            technologies: [
                "Angular",
                "TypeScript",
                "Ace Editor",
                "SweetAlert2"
            ],
            description: "In this page you can compile typescript code, it generates an equivalent code in C. Also see if it has mistakes and another reports about your code",
            link: "https://josemoran40.github.io/Proyecto2_Compi2/"
        },
        type: "web",
        code: "https://github.com/PvasquezF/ArchivosPruebaOLC2/blob/master/MatrioshTS-2s2020/Archivos%20de%20Entrada%20Proyecto%202/Arreglos/2D.ts"
    },
    {
        name: "CovidApp",
        text: "Process data of Covid-19",
        data: {
            technologies: [
                "React JS",
                "Google Maps API",
                "Bootstrap",
                "Chart JS",
                "Cloud Run"
            ],
            description: "In this page you can see data of covid group by departaments or regions in charts, if you want to have an idea of the regions go to the section infected by region, you will find a map there.",
            link: "https://covid-app-wlvcuo66pq-uc.a.run.app/region"
        },
        type: "web"
    },
    {
        name: "StoreApp",
        text: "Clothing sale app",
        data: {
            technologies: [
                "React Native",
                "React Native Elements",
                "Stripe",
                "Jest",
                "Navigation to React Native"
            ],
            description: "App designed to sale or buy clothes",
            link: "",
            images: [
                IMG9,
                IMG1,
                IMG3,
                IMG4,
                IMG5,
                IMG6,
                IMG7,
                IMG8,
                IMG11
            ]
        },
        type: "mobile"
    },
    {
        name: "Profile App",
        text: "Social media profile recreation",
        data: {
            technologies: [
                "Expo",
                "React Native",
            ],
            description: "Mobile app that simulates your profile in a social media",
            link: "https://mega.nz/file/QhETWK4S#0QlCaUPkr4Y_73Ew4N-Mx5p_QoNyJ9rzTwSsAZb1EnU",
            images: [
                profile
            ]
        },
        type: "mobile"
    }
    ]
}